export default "__VITE_ASSET__DCrJrgG0__"